module.exports = __webpack_public_path__ + "static/media/farm_pharm_19.08cf7206.jpg";